import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';

export class ImmoIPPlacerTourItemDetailNotExecutedModalHelper {
  private constructor() {}

  static getStockedAtBranchSubtitle(subProjectType: string): string {
    if (subProjectType === SUB_PROJECT_TYPES.ADJUSTMENT) {
      return 'Werd de aanpassing bij uitgestelde gezet';
    } else if (subProjectType === SUB_PROJECT_TYPES.SOLDRENTED) {
      return 'Werd de sticker bij uitgestelde gezet';
    }
    return 'Werd het bord bij uitgestelde gezet';
  }
}
